import React, { useState } from 'react';
import { MAX_ANSWER_MESSAGE_LENGTH } from '@evaltick/shared';
import { SessionInputBar } from '@/components/Interview/SessionInputBar';

interface FollowUpInputProps {
  /** Whether a follow-up can be sent right now — false while the initial rationale or a reply is still streaming. */
  canChat: boolean;
  onSend: (message: string) => void;
}

export const FollowUpInput: React.FC<FollowUpInputProps> = ({ canChat, onSend }) => {
  const [value, setValue] = useState('');

  const handleSend = () => {
    const message = value.trim();
    if (!message) return;
    setValue('');
    onSend(message);
  };

  return (
    <SessionInputBar
      value={value}
      onChange={setValue}
      onSend={handleSend}
      placeholder={canChat ? 'Ask a follow-up question…' : 'Waiting for feedback…'}
      disabled={!canChat}
      maxLength={MAX_ANSWER_MESSAGE_LENGTH}
    />
  );
};
